import { useRef, type ReactNode } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

/**
 * Wrap any block to give it a gentle scroll-driven parallax drift. The child
 * translates vertically as the wrapper passes through the viewport, adding
 * depth to photos and cards without any layout shift.
 */
export function Parallax({
  children,
  distance = 60,
  className = "",
}: {
  children: ReactNode;
  /** Total travel in px across the scroll range (positive = drifts up). */
  distance?: number;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [distance, -distance]);

  return (
    <div ref={ref} className={className}>
      <motion.div style={{ y }}>{children}</motion.div>
    </div>
  );
}
